// extracted by mini-css-extract-plugin
module.exports = {"footerRight":"footer-right_footerRight__FjMN0","soundBar":"footer-right_soundBar__26avB"};